import i18n from '@/i18n'
import { nextTick, ref, shallowRef } from 'vue'
import { templateApi } from '@/api/templateApi'
import { DashboardTemplateCategoryList, DashboardTemplateList } from '@/types/dashboard-template'
import { WidgetConfig, WidgetList } from '@/types/dashboard'
import { getWidgetTemplate } from '@/composables/globalData/useTemplatesCategoryData'

export default function useDashboardTemplates () {
    const dashboardTemplatesLoading = ref(false)
    const dashboardTemplates = shallowRef<Array<DashboardTemplateCategoryList>>([])

    async function fetchDashboardTemplates () {
        try {
            dashboardTemplatesLoading.value = true
            dashboardTemplates.value = await templateApi.getDashboardTemplates()
        } catch (e) {
            console.warn(e)
        } finally {
            nextTick(() => {
                dashboardTemplatesLoading.value = false
            })
        }
    }

    function getWidgetListFromTemplate (template?: DashboardTemplateList): Array<Partial<WidgetList>> {
        if (!template) {
            return []
        }

        return template?.WidgetTemplateList?.map(widget => {
            const Title = i18n.te(widget.DefaultWidgetTitleContentTag)
                ? i18n.t(widget.DefaultWidgetTitleContentTag)
                : widget.DefaultWidgetTitle || ''
            const templateData = getWidgetTemplate(widget.WidgetTemplateID)
            const defaultWidgetConfig = (widget.DefaultWidgetConfig.length ? widget.DefaultWidgetConfig.filter((item, index, self) => {
                return index === self.findIndex(i => i.ParameterID === item.ParameterID)
            }) : templateData?.DefaultWidgetConfig || []) as Array<WidgetConfig>
            return {
                Title: String(Title),
                WidgetLayout: widget.WidgetLayout,
                WidgetTime: widget.WidgetTime,
                WidgetConfig: defaultWidgetConfig,
                TemplateID: widget.WidgetTemplateID
            }
        })
    }

    return {
        dashboardTemplatesLoading,
        dashboardTemplates,
        fetchDashboardTemplates,
        getWidgetListFromTemplate
    }
}
